import { HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiGateway } from '@sb/shared/api';
import { IGNORE_META_ERROR_MESSAGE } from '@sb/shared/util';
import { map } from 'rxjs';

import type { PendingHire, PendingHires, PendingHiresMeta } from './pending-hires.model';

@Injectable({ providedIn: 'root' })
export class PendingHiresApiService {
  #api = inject(ApiGateway);

  list() {
    return this.#api
      .get<{ data: PendingHire[]; meta: PendingHiresMeta }>('hiring/pending-hires', {
        meta: true,
        context: new HttpContext().set(IGNORE_META_ERROR_MESSAGE, true),
      })
      .pipe(
        map((response): PendingHires => ({
          rows: response.data,
          scopeLocationIds: response.meta.scope_location_ids,
        })),
      );
  }
}
